import { render, staticRenderFns } from "./AdminPanelYoutvPackageSelling.vue?vue&type=template&id=8fc28e5e&"
import script from "./AdminPanelYoutvPackageSelling.vue?vue&type=script&lang=js&"
export * from "./AdminPanelYoutvPackageSelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports